import QuillCheat from "./quill-cheat/QuillCheat";

const api = {
  quillCheat: <QuillCheat />,
};

export default api;
